import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import toast, { Toaster } from "react-hot-toast";
import Icon from "@mdi/react";
import {
    mdiCalendar,
    mdiClose,
    mdiCloudUploadOutline,
    mdiPencilOutline,
    mdiLoading,
} from "@mdi/js";
import { useForm } from "react-hook-form";
import InputFloatingStyle from "../../../../sass/floatingLabel.scss";

import Styles from "./FormDetailDecision.scss";
import FormDetailAvisDecision from "./FormDetailAvisDecision";
import Swal from "sweetalert2";
import DatePicker from "react-date-picker";
import FloatingInputSuiviDossier from "./FloatingInputSuiviDossier";

const FormDetailDecision = (props) => {
    const [formRef, setFormRef] = useState();
    const [loading, setLoading] = useState();
    const [dialog, setDialog] = useState();
    const [dateDem, setDateDem] = useState(new Date());
    const [dateValid, setDateValid] = useState(new Date());
    const [doc, setDoc] = useState("");
    const [url, setUrl] = useState();
    const [param, setParam] = useState();
    const [newState, setNewState] = useState();
    const [updateCound, setUpdateCount] = useState(0);
    const {
        reset,
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        defaultValues: {
            doc_link: props?.currentDetailForm?.form_state?.doc_link,
        },
    });

    useEffect(() => {
        setLoading(true);
        setFormRef(props.currentDetailForm);
        setDialog(document.querySelector("#doc_dialog"));
        setDateDem(new Date(props.currentDetailForm.dem_date));
        setDateValid(
            props.currentDetailForm.dem_valide
                ? new Date(props.currentDetailForm.dem_valide)
                : new Date()
        );
        setUrl(props?.currentDetailForm?.form_state?.doc_link);
        setDoc(props?.currentDetailForm?.form_state?.doc);
        setLoading(false);
        //setTCustomPdf(props?.currentDetailForm?.form_state?.doc_link);
    }, []);

    useEffect(() => {
        //console.log("useEffect url : ",url)
        handleUpdateDoc();
    }, [url]);

    const onURlSubmit = (e) => {
        setUrl(e.doc_link);
        //console.log("change url", e.doc_link)
        handleUpdateDoc(e.doc_link);
        dialog.close();
    };

    const handleURLReset = () => {
        reset({ doc_link: "" });
        setUrl(null);
        //handleUpdateDoc()
        console.log("reset url", url);
        dialog?.close();
    };

    const onOptionChange = async (e) => {
        /*   if(e==='default'){
            setUrl(null);
            setDoc(null);
        }else{

        }*/
    };

    useEffect(() => {
        /*setDoc((props?.currentDetailForm?.form_state?.doc_label)?props.currentDetailForm.form_state.doc_label:"")
        setUrl((props?.currentDetailForm?.form_state?.doc_link)?props.currentDetailForm.form_state.doc_link:"")
        setNewState((props?.currentDetailForm?.form_state?.state_id)?props.currentDetailForm.form_state.state_id:0)*/
    }, [props.currentDetailForm]);

    const onUpdateState = (type, state) => {
        setNewState(state);
    };

    const handleOnChange = (e) => {
        setFormRef({
            ...formRef,
            [e.target.name]: e.target.value,
        });
    };

    const onChangeDoc = (e) => {
        e === "custom" && !doc ? dialog.showModal() : null;
        setDoc(e.target.value);
    };

    useEffect(() => {
        let update = async () => {
            let newDate = {
                target: {
                    name: "dem_date",
                    value: new Date(dateDem).toDateString(),
                },
            };
            await UpdateForm(newDate);
        };
        dateDem ? update() : null;
    }, [dateDem]);

    useEffect(() => {
        let update = async () => {
            let newDate = {
                target: {
                    name: "dem_valide",
                    value: new Date(dateValid).toDateString(),
                },
            };
            await UpdateForm(newDate);
        };
        dateValid ? update() : null;
    }, [dateValid]);

    useEffect(() => {
        newState !== undefined ? handleUpdateDoc() : null;
    }, [newState]);

    const handleUpdateDoc = (urlVal = null) => {
        setLoading(true);
        let args = {
            doc_label: doc,
            doc_link: urlVal ? url : url,
            date_demande: new Date(dateDem),
            date_valid: new Date(dateValid),
            state_id: newState,
        };
        try {
            let result = axios.put(
                "/Api/Form_ref/detail/" + formRef.id + "/form_state",
                args
            );
            props.setCurrentDetailForm({
                ...props.currentDetailForm,
                form_state: result?.data?.form_state,
            });
            toast.success("Actualisation de vos données réussie", {
                id: "success-detail",
            });
        } catch (e) {
            // toast.error('Un problème est survenu lors de l`\'actualisation de vos données', {id:"toast-error-doc"});
        }
        dialog?.close();
        setLoading(false);
    };

    const UpdateForm = async (e) => {
        let args = {
            ...formRef,
            dem_date: new Date(dateDem),
            dem_valide: new Date(dateValid),
            dem_state: 1,
            [e.target.name]: e.target.value,
        };
        try {
            const resultFormRef = await axios.post(
                "/Api/Form_ref/detail/" + formRef.id + "/update",
                args
            );
            toast.success("Actualisation de vos données réussie", {
                id: "success-detail",
            });
            props.setCheckForm(true);
        } catch (e) {
            //toast.error('Un problème est survenu lors de l`\'actualisation de vos données de formulaire',{id:'error'});
        }
    };

    return (
        <div
            className={
                "d-flex flex-column justify-content-center items-center ue-form-detail-avis pl-3 pr-3"
            }
        >
            <div className={"h5 font-weight-bolder text-left my-2"}>
                Décision
            </div>
            <div
                className={
                    "d-flex flex-row my-2 w-100 text-center justify-content-between align-items-center text-dark"
                }
            >
                {loading ? (
                    <div
                        className={
                            "d-flex w-100 justify-content-center items-center"
                        }
                    >
                        <Icon
                            path={mdiLoading}
                            spin={true}
                            size={1.5}
                            color={"var(--theeme-primary"}
                        />
                    </div>
                ) : (
                    <div className={"ue-form-detail-decision w-100"}>
                        <div className="form-group d-flex flex-column justify-content-start w-100">
                            <div>
                                {/* <label
                                    htmlFor={"code"}
                                    className={"ue-input-label_inside"}
                                >
                                    N° de dossier
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="code"
                                    name="code"
                                    value={formRef?.code || ""}
                                    onChange={handleOnChange}
                                    onBlur={UpdateForm}
                                /> */}
                                <div className="did-floating-label-content">
                                    <input
                                        className="did-floating-input"
                                        type="text"
                                        id={"code"}
                                        name={"code"}
                                        placeholder=" "
                                        value={formRef?.code || ""}
                                        onChange={handleOnChange}
                                        onBlur={UpdateForm}
                                    ></input>
                                    <label className="did-floating-label">
                                        N° de dossier
                                    </label>
                                </div>
                            </div>
                            <div
                                className={
                                    "d-flex flex-column flex-md-row justify-content-between w-100"
                                }
                            >
                                <div className="d-flex flex-column justify-content-start align-items-center mr-3 w-50 ue-form-decision-date">
                                    <label
                                        className={"bad-ue-input-label_inside"}
                                        htmlFor={"dem_date"}
                                    >
                                        Date de la demande
                                    </label>
                                    <DatePicker
                                        onChange={setDateDem}
                                        clearIcon={null}
                                        calendarIcon={
                                            <Icon
                                                path={mdiCalendar}
                                                size={0.67}
                                                color={"#58D2C3"}
                                            />
                                        }
                                        value={dateDem}
                                        local={"fr-FR"}
                                        name={"dem_date"}
                                        id={"dem_date"}
                                    />
                                </div>
                                <div className="d-flex flex-column justify-content-start align-items-center  w-50 ue-form-decision-date">
                                    <label
                                        className={"bad-ue-input-label_inside"}
                                        htmlFor={"dem_date"}
                                    >
                                        Date de la fin d'instruction
                                    </label>
                                    <DatePicker
                                        onChange={setDateValid}
                                        clearIcon={
                                            <Icon
                                                path={mdiClose}
                                                size={0.67}
                                                color={"#58D2C3"}
                                            />
                                        }
                                        calendarIcon={
                                            <Icon
                                                path={mdiCalendar}
                                                size={0.67}
                                                color={"#58D2C3"}
                                            />
                                        }
                                        value={dateValid}
                                        local={"fr-FR"}
                                        name={"dem_valide"}
                                        id={"dem_valide"}
                                    />
                                </div>
                            </div>
                            <div className="form-group ue-form-goup-input d-flex flex-column justify-content-start w-100">
                                <label
                                    className={
                                        "text-center text-md-left ue-input-label_inside"
                                    }
                                >
                                    Décision de l'instructeur
                                </label>
                                    <FormDetailAvisDecision
                                        className={""}
                                        size={"lg"}
                                        state={newState}
                                        onUpdateState={onUpdateState}
                                    />
                                </div>

                                <div className="d-flex flex-column justify-content-start w-100">
                                    {/* <label
                                    htmlFor="comment"
                                    className={
                                        "text-center text-md-left ue-input-label_inside"
                                    }
                                >
                                    Observations{" "}
                                </label>
                                <textarea
                                    className="form-control "
                                    id="comment"
                                    name={"comment"}
                                    rows="8"
                                    onChange={handleOnChange}
                                    onBlur={UpdateForm}
                                    value={
                                        formRef?.comment ? formRef.comment : ""
                                    }
                                /> */}


                                    <div className="form-group ue-form-goup-input d-flex flex-column justify-content-start w-100">
                                        <label className={"text-center text-md-left ue-input-label_inside"}>
                                            Observations
                                        </label>
                                        <textarea
                                            className="form-control pt-3"
                                            name="comment"
                                            rows="8"
                                            onChange={handleOnChange}
                                            onBlur={UpdateForm}
                                            value={
                                                formRef?.comment
                                                    ? formRef.comment
                                                    : ""
                                            }
                                        />
                                    </div>
                                </div>

                                <div
                                    className={
                                        "d-flex flex-column justify-content-start align-items-start w-100"
                                    }
                                >
                                    <div className={"font-weight-bold my-3"}>
                                        Formulaire disponible à télécharger
                                    </div>
                                    <div
                                        className={
                                            "form-group d-flex flex-column justify-content-start align-items-start w-100"
                                        }
                                    >
                                        <div
                                            className={
                                            "d-flex justify-content-start align-items-center w-100"
                                        }
                                    >
                                        <div
                                            onClick={() => {
                                                setUrl("");
                                                handleUpdateDoc();
                                            }}
                                            className={"text-primary my-3 mr-3"}
                                            style={{ cursor: "pointer" }}
                                        >
                                            {!url ? (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-record-circle-fill"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-8 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                                                </svg>
                                            ) : (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-circle"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                </svg>
                                            )}
                                        </div>
                                        <div className="ue-input-factice">
                                            Document par défaut
                                        </div>
                                    </div>
                                    <div
                                        className={
                                            "d-flex justify-content-start align-items-center w-100"
                                        }
                                    >
                                        <div
                                            onClick={(e) => dialog.showModal()}
                                            className={"text-primary my-3 mr-3"}
                                            style={{ cursor: "pointer" }}
                                        >
                                            {url ? (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-record-circle-fill"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-8 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                                                </svg>
                                            ) : (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-circle"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                </svg>
                                            )}
                                        </div>
                                        <div className="ue-input-factice d-flex justify-content-between ">
                                            <div
                                                id="ue-input-factice"
                                                onClick={(e) =>
                                                    doc
                                                        ? window.open(
                                                              url,
                                                              "_blanck"
                                                          )
                                                        : dialog.showModal()
                                                }
                                            >
                                                {url
                                                    ? url
                                                    : "Importer un document personnalisé"}
                                            </div>
                                            <div
                                                className="ue-form-detail-decision-link-btn"
                                                style={{ cursor: "pointer" }}
                                                onClick={(e) =>
                                                    dialog.showModal()
                                                }
                                            >
                                                {/* {url ? (
                                                    <Icon
                                                        path={mdiPencilOutline}
                                                        size={0.8}
                                                        color={
                                                            "var(--theme-primary)"
                                                        }
                                                    />
                                                ) : (
                                                    <Icon
                                                        path={
                                                            mdiCloudUploadOutline
                                                        }
                                                        size={0.8}
                                                        color={
                                                            "var(--theme-primary)"
                                                        }
                                                    />
                                                )} */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <dialog id={"doc_dialog"} className={"ue-service-dialog"}>
                <header>
                    <div className={"d-flex justify-content-between w-100"}>
                        <div className={"font-weight-bold my-2"}>
                            SUIVI DE DOSSIER :
                        </div>
                        <div
                            onClick={(e) => dialog.close()}
                            style={{ cursor: "pointer" }}
                        >
                            <svg
                                width="11"
                                height="11"
                                viewBox="0 0 10 10"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M5.00005 3.93955L8.71255 0.227051L9.77305 1.28755L6.06055 5.00005L9.77305 8.71255L8.71255 9.77305L5.00005 6.06055L1.28755 9.77305L0.227051 8.71255L3.93955 5.00005L0.227051 1.28755L1.28755 0.227051L5.00005 3.93955Z"
                                    fill="#333333"
                                />
                            </svg>
                        </div>
                    </div>
                </header>
                <main>
                    <div
                        className={
                            "d-flex justify-content-between w-100 align-items-center "
                        }
                    ></div>
                    <div
                        className={
                            "d-flex flex-column w-100 font-weight-bolder"
                        }
                    >
                        <form
                            id={"doc_from"}
                            className={"form w-100"}
                            onSubmit={handleSubmit(onURlSubmit)}
                        >
                            <div
                                className={
                                    "d-flex justify-content-between align-items-center w-100 text-white "
                                }
                                style={{
                                    backgroundColor:
                                        "var(--theme-page-background-alternate)",
                                    padding: "10px",
                                    borderRadius: "4px",
                                }}
                            >
                                Importer le formulaire
                                <div>
                                    <button
                                        onClick={() => {
                                            handleURLReset();
                                        }}
                                        className="btn font-weight-bold mr-md-2"
                                        style={{
                                            backgroundColor: "#c673e6",
                                            fontSize: "0.65rem",
                                        }}
                                        type="button"
                                    >
                                        RETOUR
                                    </button>
                                    <button
                                        type={"submit"}
                                        className={
                                            "btn btn-primary btn-md text-white font-weight-bold"
                                        }
                                        style={{ fontSize: "0.65rem" }}
                                    >
                                        VALIDER
                                    </button>
                                </div>
                            </div>
                            <div
                                className={
                                    "d-flex flex-column flex-md-row w-100 "
                                }
                                style={{ marginTop: "40px" }}
                            >
                                <label
                                    className={"mr-2"}
                                    htmlFor={"doc_link"}
                                    style={{ width: "90px" }}
                                >
                                    Lien URL{" "}
                                </label>
                                <input
                                    className={
                                        "form-control ue-form-control w-100"
                                    }
                                    style={{
                                        height: "auto",
                                        border: "1px solid #ececec",
                                    }}
                                    type={"text"}
                                    name={"doc_link"}
                                    id={"doc_link"}
                                    {...register("doc_link", {
                                        required: "L'url ne peut être vide !",
                                    })}
                                />
                                <div className={" my-2 mx-2"}>
                                    {errors.doc_link && (
                                        <span className={"ue-form-error"}>
                                            L'url ne peu être vide !
                                        </span>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>
                </main>
            </dialog>
        </div>
    );
};
const mapStateToProps = (state) => {
    return {
        role: state.MeReducer.role,
        centerPageArg: state.DashboardReducer.centerPageArg,
        uiThem: state.AppReducer.uiThem,
        currentDetailForm: state.FormsReducer.currentDetailForm,
    };
};

const mapDispatchTProps = (dispatch) => {
    return {
        showCenterSection: (e) =>
            dispatch({ type: "SHOW_CENTER_SECTION", data: e }),
        setCurrentCenterPage: (e) =>
            dispatch({ type: "SET_CURRENT_PAGE", data: e }),
        setCheckForm: (e) => dispatch({ type: "SET_CHECK_FORMS", data: e }),
        setCurrentDetailForm: (e) =>
            dispatch({ type: "SET_CURRENT_DETAIL_FORM", data: e }),
    };
};

export default connect(mapStateToProps, mapDispatchTProps)(FormDetailDecision);
